// src/components/chatbot/AnonymousChatbotPage.jsx
import React from "react";
import { Container, Segment, Header, Icon, Label, Popup } from "semantic-ui-react";
import Chatbot from "./Chatbot"; // pas dit pad aan als jouw Chatbot elders staat
import VivaHubLogo from "../../images/vivahub-logo-orange.svg";

const VIVAHUB_GRADIENT =
  "linear-gradient(135deg, #FCD34D 0%, #F59E0B 35%, #D97706 65%, #DC2626 100%)";

export default function AnonymousChatbotPage() {
  return (
    <div
      style={{
        // Warmere VivaHub-achtergrond i.p.v. koel blauw
        background:
          "radial-gradient(1200px 400px at 20% 0%, rgba(252, 211, 77, 0.18), transparent 60%)," +
          "radial-gradient(900px 380px at 90% 10%, rgba(220, 38, 38, 0.10), transparent 55%)," +
          "#fbfbfc",
        minHeight: "55vh",
        padding: "26px 12px"
      }}
    >
      <Container>
        {/* VivaHub framing card */}
        <Segment
          style={{
            maxWidth: 980,
            margin: "0 auto 14px",
            borderRadius: 18,
            border: "1px solid rgba(17, 24, 39, 0.08)",
            boxShadow: "0 10px 28px rgba(17, 24, 39, 0.08)",
            padding: 0,
            overflow: "hidden",
            background: "#fff"
          }}
        >
          {/* top accent bar */}
          <div style={{ height: 6, background: VIVAHUB_GRADIENT }} />

          <div style={{ padding: "16px 16px 14px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: 14
              }}
            >
              {/* icon tile */}
              <div
                style={{
                  width: 46,
                  height: 46,
                  borderRadius: 16,
                  background:
                    "linear-gradient(180deg, rgba(252, 211, 77, 0.20), rgba(220, 38, 38, 0.10))",
                  border: "1px solid rgba(17, 24, 39, 0.08)",
                  boxShadow: "0 6px 14px rgba(0,0,0,0.06)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flex: "0 0 auto"
                }}
              >
                <Icon name="comment alternate" size="large" style={{ color: "#B45309" }} />
              </div>

              <div style={{ flex: 1 }}>
                {/* subtle badges */}
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 8 }}>
                  <Popup
                    content="VivaHub is een lokaal initiatief dat mensen helpt de weg te vinden naar welzijn en ondersteuning in hun buurt."
                    position="bottom center"
                    inverted
                    trigger={
                      <Label
                        size="tiny"
                        style={{
                          background: "rgba(252, 211, 77, 0.18)",
                          color: "#7C2D12",
                          border: "1px solid rgba(124, 45, 18, 0.16)",
                          cursor: "help"
                        }}
                      >
                        VivaHub
                      </Label>
                    }
                  />
                  <Popup
                    content="Dit gesprek is volledig anoniem. We slaan geen naam, adres of contactgegevens op."
                    position="bottom center"
                    inverted
                    trigger={
                      <Label
                        size="tiny"
                        style={{
                          background: "rgba(17, 24, 39, 0.05)",
                          color: "#111827",
                          border: "1px solid rgba(17, 24, 39, 0.08)",
                          cursor: "help"
                        }}
                      >
                        <span role="img" aria-label="lock">🔒</span>{" "}
                        Anoniem
                      </Label>
                    }
                  />

                  <Popup
                    content="Het aanbod dat Zippy toont, wordt gecontroleerd en gevalideerd door VivaHub en lokale partners."
                    position="bottom center"
                    inverted
                    trigger={
                      <Label
                        size="tiny"
                        style={{
                          background: "rgba(16, 185, 129, 0.10)",
                          color: "#065F46",
                          border: "1px solid rgba(6, 95, 70, 0.18)",
                          cursor: "help"
                        }}
                      >
                        <Icon name="check circle" style={{ marginRight: 6 }} />
                        Geverifieerd aanbod
                      </Label>
                    }
                  />

                  <Popup
                    content="Zippy is gebouwd met Europese technologie en volgt Europese regels rond privacy en databescherming."
                    position="bottom center"
                    inverted
                    trigger={
                      <Label
                        size="tiny"
                        style={{
                          background: "rgba(59, 130, 246, 0.08)",
                          color: "#1E3A8A",
                          border: "1px solid rgba(30, 58, 138, 0.16)",
                          cursor: "help"
                        }}
                      >
                        <span role="img" aria-label="eu">🇪🇺</span>{" "}
                        Europese technologie
                      </Label>
                    }
                  />
                </div>

                <Header
                  as="h2"
                  style={{
                    margin: 0,
                    fontSize: 22,
                    lineHeight: 1.2,
                    color: "#111827"
                  }}
                >
                  Zippy luistert 👋
                </Header>

                <div style={{ marginTop: 6, color: "rgba(17, 24, 39, 0.72)", fontSize: 14, lineHeight: 1.5 }}>
                  Stel gerust je vraag. Dit gesprek is anoniem — deel geen gegevens zoals je naam,
                  adres of telefoonnummer.
                  <br />
                  We vragen wel in welke gemeente je woont, zodat Zippy je zo goed mogelijk de weg
                  kan wijzen naar ondersteuning in de buurt.
                  <div style={{ marginTop: 8, color: "rgba(17, 24, 39, 0.60)" }}>
                    Zippy helpt je digitaal op weg. In onze VivaHub-kiosk kan je ook terecht voor warme,
                    menselijke ondersteuning.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Segment>

        {/* Chatbot area – tip: laat Chatbot zelf transparant/zonder eigen page background renderen */}
        <div style={{ maxWidth: 980, margin: "0 auto" }}>
          <Chatbot
            anonymous
            apiBaseUrl="https://acc.api.zipster.care" />
        </div>

        {/* Footer reassurance */}
        {/* Footer reassurance */}
        <div
          style={{
            maxWidth: 980,
            margin: "12px auto 0",
            padding: "8px 4px 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            color: "rgba(17, 24, 39, 0.55)",
            fontSize: 12,
            flexWrap: "wrap"
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span
              style={{
                width: 10,
                height: 10,
                borderRadius: 999,
                background: VIVAHUB_GRADIENT
              }}
            />
            Dit gesprek is anoniem en bedoeld om je op weg te helpen. Bij dringende nood:
            contacteer je huisarts of 112.
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 8, opacity: 0.7 }}>
            <img
              src={VivaHubLogo}
              alt="VivaHub"
              style={{ height: 20, width: "auto" }}
            />
          </div>
        </div>
      </Container>
    </div>
  );
}